<template>
  <div class="form-panel">
    <p class="form-panel__title"><i class="mdi mdi-filter-variant"></i>Filtrar por</p>
    <div class="form-panel__field">
      <date-picker 
        label="Data do Parto"
        dense
        :binding.sync="filter.date_birth"
        :readOnly="false"
      />
    </div>

    <div class="form-panel__field">
      <date-picker 
        label="Data do Encerramento"
        dense
        :binding.sync="filter.date_explanation"
        :readOnly="false"
      />
    </div>

    <v-select
      class="form-panel__field"
      outlined
      dense
      label="Ordem"
      v-model="filter.order"
      :items="computedOrders"
      item-text="title"
      item-value="id"
    ></v-select>

    <v-text-field
      class="form-panel__field"
      outlined
      dense
      label="Valor Base"
      v-model="filter.base_value"
    ></v-text-field>

    <v-autocomplete
      class="form-panel__field"
      outlined
      dense
      label="Grau de Sangue"
      item-text="title"
      item-value="id"
      :items="bloodDegrees"
      v-model="filter.blood_degree"
      no-data-text="Nenhum resultado..."
      clearable
    ></v-autocomplete>

    <div class="form-panel__actions">
      <v-btn 
        class="success"
        @click="submit"
      >
        <i class="mdi mdi-file-chart-outline pr-1"></i>
        Gerar Relatório
      </v-btn>
    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/layout/DatePicker";

export default {
  name:"ReportFilters",
  props:{
    bloodDegrees:Array
  },
  components:{
    DatePicker
  },
  data() {
    return {
      filter:{}
    }
  },
  computed: {
    computedOrders() {
      const orders = [];
      for(let i = 1; i < 100; i++) {
        if(i === 1) {
          orders.push({title:"Primeiro Parto", id:i});
        }
        orders.push({title:i.toString(), id:i})
      }
      return orders;
    }
  },
  methods: {
    submit() {
      if(!Object.keys(this.filter).length) {
        this.$toast.warning("Nenhum filtro de pesquisa aplicado !");
        return
      }
      this.$emit("get-report", this.filter);
    }
  }
}
</script>